// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__JmpNC","formButton":"Buttons_formButton__DFcQr","new_formbutton":"Buttons_new_formbutton__20FAk"};